import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { TargetingAdminStore } from './stores';
import { LocalizationService } from "../../services/LocalizationService";
import { IAPivot } from '../pivot/Pivot';
import UserGroup from './components/userGroup/UserGroup';
import { ProfileData } from './components/profileData/ProfileData';
import { TargetingService } from '../../services/TargetingService';
import { Applications } from './components/applications/Applications';
import { IApplication, Instance } from './../../interfaces/IApplication';
import { IHttpStatus } from '../../interfaces/IHttpStatus';
import { ITargetingProperties } from '../../interfaces/ITargetingProperties';
import { LoggingService } from '../../services/LoggingService';
import { Helper } from '../../Helper';

export interface ITargetingAdminProps {
  targetingStore?: TargetingAdminStore;
}

@inject('targetingStore')
@observer
export class OldTargetingAdmin extends React.Component<ITargetingAdminProps> {


  constructor(props: ITargetingAdminProps) {
    super(props);
    LoggingService.init(this.props.targetingStore.environment);
    if (this.props.targetingStore.language != undefined) {
      this.props.targetingStore.setLanguage(this.props.targetingStore.language);
    }
    this.props.targetingStore.isLoadingApplication = true;
    this.props.targetingStore.isLoadingProfileData = true;
    this.loadGroups();
    this.loadUserProperties();
    this.loadAdminData();
  }


  public componentDidMount(): void {
    this.props.targetingStore.loading = true;
  }

  public componentWillReceiveProps(props: ITargetingAdminProps): void {
    if (this.props.targetingStore.reloadComponent && !this.props.targetingStore.loading) {
      this.props.targetingStore.reloadComponent = false;
    }
    if (this.props.targetingStore.language != undefined) {
      this.props.targetingStore.setLanguage(props.targetingStore.language);
    }
    this.loadAdminData();
  }

  private loadAdminData() {
    this.promiseLoadGroups();
    this.promiseLoadTerms();
    this.promiseLoadProperties();
    this.promiseLoadApplicationSettings();
    // this.props.targetingStore.loading = false;
  }

  private promiseLoadGroups = (): Promise<void> => {

    this.props.targetingStore.groupListItem = [];
    this.props.targetingStore.groupedList = undefined;
    this.props.targetingStore.groupsList = [];
    return new Promise<void>((resolve: () => void): void => {
      TargetingService.getGroups(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token).then((groups) => {
        this.props.targetingStore.transformDataToGroupList(groups);
        this.props.targetingStore.loading = false;
        resolve();
      });
    });
  }


  private loadGroups = () => {

    this.props.targetingStore.groupListItem = [];
    this.props.targetingStore.groupedList = undefined;
    this.props.targetingStore.groupsList = [];

    TargetingService.getGroups(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token).then((groups) => {
      this.props.targetingStore.transformDataToGroupList(groups);
      // this.props.targetingStore.loading = false;
    });
  }


  private loadProperties = () => {
    TargetingService.getProperties(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token, true).then((response: { httpStatus: IHttpStatus, value?: ITargetingProperties[] }) => {
      this.props.targetingStore.updatePropertiesList(response.value);
      if (!localStorage.getItem("Terms")) {
        TargetingService.getDefaultTerms(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token).then((terms) => {
          Helper.setLocalStorage("Terms", JSON.stringify(terms));
          this.props.targetingStore.updateTerms(terms);
        });
      }
    });
  }

  private promiseLoadTerms = (): Promise<void> => {
    if (!localStorage.getItem("Terms")) {
      return new Promise<void>((resolve: () => void): void => {
        TargetingService.getDefaultTerms(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token).then((terms) => {
          Helper.setLocalStorage("Terms", JSON.stringify(terms));
          this.props.targetingStore.updateTerms(terms);
          resolve();
        });
      });
    }
    this.props.targetingStore.updateTerms(JSON.parse(localStorage.getItem("Terms")));
    return;
  }

  private promiseLoadProperties = (): Promise<void> => {
    return new Promise<void>((resolve: () => void): void => {
      TargetingService.getProperties(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token, true).then((response: { httpStatus: IHttpStatus, value?: ITargetingProperties[] }) => {
        this.props.targetingStore.updatePropertiesList(response.value);
        TargetingService.getDefaultTerms(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token).then((terms) => {
          Helper.setLocalStorage("Terms", JSON.stringify(terms));
          this.props.targetingStore.updateTerms(terms);
          resolve();
        });
      });
    });
  }

  private promiseLoadApplicationSettings = (): Promise<void> => {
    return new Promise<void>((resolve: () => void): void => {
      TargetingService.getApplicationsTargetSettings(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token).then((applications: IApplication[]) => {
        let applicationsList: IApplication[] = [];

        applicationsList = applications.map(application => {
          let instancesRemoved: Instance[] = [];
          let instanceList = this.props.targetingStore.instancesList[application.title];
          if (instanceList) {
            application.instances.forEach(instance => {
              let instanceData = instanceList.find(x => x.instance === instance?.id);
              if (!instanceData) {
                instancesRemoved.push(instance);
              }
            });
            if (instancesRemoved.length > 0) {
              instancesRemoved.forEach(removed => {
                const index = application.instances.findIndex(x => x.id == removed.id);
                if (index !== undefined) {
                  application.instances.splice(index, 1);
                }
              });
            }
            instanceList.forEach(instance => {
              let instanceData = application.instances.find(x => x.id === instance.instance);
              if (!instanceData) {

                if (typeof (application.default.isEnable) === "string") {
                  application.default.isEnable = (/true/i).test(application.default.isEnable);
                }

                let newInstance: Instance =
                {
                  allValues: false,
                  isEnable: application.default.isEnable,
                  useDefault: true,
                  id: instance.instance,
                  name: instance.title,
                  values: [],
                  type: application.default.type
                };
                application.instances.push(newInstance);
              } else {
                instanceData.name = instance.title;
              }
            });
          }
          return application;
        });
        this.props.targetingStore.applicationsData = applicationsList;
        this.props.targetingStore.isLoadingApplication = false;
        resolve();
      });
    });
  }

  private loadTerms = () => {
    if (!localStorage.getItem("Terms")) {
      TargetingService.getDefaultTerms(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token).then((terms) => {
        Helper.setLocalStorage("Terms", JSON.stringify(terms));
        this.props.targetingStore.updateTerms(terms);
      });
    } else {
      this.props.targetingStore.updateTerms(JSON.parse(localStorage.getItem("Terms")));
    }
  }

  private loadUserProperties = () => {
    TargetingService.getProfileDataProperties(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token).then(properties => {
      this.props.targetingStore.updateUserProperties(properties);
      this.props.targetingStore.isLoadingProfileData = false;
    });
  }

  // private loadApplicationSettings = () => {
  //   TargetingService.getApplicationsTargetSettings(this.props.targetingStore.targetingProperties, this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token).then((applications: Application[]) => {
  //     let applicationsList: Application[] = [];

  //     applicationsList = applications.map( application => {
  //       let instanceList = this.props.targetingStore.instancesList[application.title];
  //       if (instanceList) {
  //         instanceList.forEach( instance => {
  //           let instanceData = application.instances.find(x => x.id === instance.instance);
  //           if (!instanceData) {
  //             let newInstance: Instance = 
  //             {
  //               allValues: false,
  //               isEnable: true,
  //               useDefault: true,
  //               id: instance.instance,
  //               name: instance.title,
  //               values: []
  //             };
  //             application.instances.push(newInstance);
  //           }
  //         });
  //       }
  //       return application;
  //     });
  //     this.props.targetingStore.applicationsData = applicationsList;
  //     this.props.targetingStore.isLoadingApplication = false;
  //   });
  // }

  public reloadData = () => {
    this.loadProperties();
  }

  public render(): JSX.Element {


    return (
      <div>
        <IAPivot
          highlightColor="#23879b"
          items={[
            {
              key: "ProfileData",
              text: new LocalizationService().strings.TargetingAdmin_PropertyPanelTitle
            },
            {
              key: "UserGroups",
              text: new LocalizationService().strings.TargetingAdmin_ApplicationSettingsUserGroups,
            },
            {
              key: "Applications",
              text: new LocalizationService().strings.TargetingAdmin_Applications,
            },
          ]}
          selectedKey={this.props.targetingStore.selectedTab}
          select={(display: string) => this.props.targetingStore.selectedTab = display}
        />

        {this.props.targetingStore.selectedTab === "UserGroups" &&
          <UserGroup reloadGroups={() => { this.loadGroups(); console.log("was reloaded"); }} />
        }
        {this.props.targetingStore.selectedTab === "ProfileData" &&
          <ProfileData reloadTerms={() => this.loadTerms()} reloadData={() => this.reloadData()} />
        }
        {this.props.targetingStore.selectedTab === "Applications" &&
          <Applications />
        }

      </div>
    );
  }



}